import { AuthGuard, CrudOp, targetAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const IdManagerView: FC = () => {
  const tmmId = useRequiredSubprojectParam("tmmId");
  return (
    <AuthGuard authScope={targetAuthScope} crudOp={CrudOp.READ}>
      <Suspense><LazyIdManagerView tmmId={tmmId}/></Suspense>
    </AuthGuard>
  );
};

const LazyIdManagerView = lazy(importView(
  () => import("../components/IdManagerView"),
  (it) => it.IdManagerView,
));
